/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/*
 * Segmented Button Component for Grid/List view
 *
 */
import './ViewSegmentedButton.scss';
import Util from '../util/Util';
import Locale from '../util/Locale';

function renderButton(isActive, isGridIcon, onClick, title) {
    const color = isActive ? 'white' : '#00528A';
    const icon = isGridIcon ? Util.getGridViewIcon(color) : Util.getListViewIcon(color);
    if (isActive) {
        return (
            <nsemble-button primary title={title}>
                <div className="svgBlock">{icon}</div>
            </nsemble-button>
        );
    }
    return (
        <nsemble-button onClick={onClick} title={title}>
            <div className="svgBlock">{icon}</div>
        </nsemble-button>
    );
}

export default function ViewSegmentedButton(props) {
    const isGridActive = !props || props.active;
    const onClick = props && props.onClick ? props.onClick : () => {};
    return (
        <div className="segmentedButton">
            {renderButton(isGridActive, true, onClick, Locale.getText('GRID_VIEW'))}
            {renderButton(!isGridActive, false, onClick, Locale.getText('LIST_VIEW'))}
        </div>
    );
}
